import React from 'react'
// Styles
import { FlexibleHeroContainer, MainImage, VerticalGrid } from './style'

// Components
import Breadcrumbs from '../breadcrumbs'
import Button from '../button'
import GlobalContainer from '../globalContainer'
import Typography from '../typography'
import WrapperImage from '../wrapperImage'

// Constants
import { backgroundThemes, useCases } from '../../../constants/contentfulStyle.constant'

// Utils
import ImgUtil from '../../../utils/img.utils'
import formatInlineCode from '../../../utils/shortTextFormatting'

const FlexibleHero = ({
  data,
  showBreadcrumbs,
  locale,
  location,
  pageTitle,
  breadcrumb,
  pageType,
}: any) => {
  if (!data) return null
  const backgroundImageUrl = data.backgroundImage?.image?.file?.url
  const mainImageUrl = data.mainImage?.image?.file?.url
  const logoUrl = data.logo?.image?.file?.url

  const theme = {
    backgroundUrl: backgroundImageUrl,
    backgroundTheme: data.theme,
    isDarkTheme: data.theme === backgroundThemes.DARK,
    useCase: data.useCase,
    showBreadcrumbs: showBreadcrumbs,
  }

  const mainImage = (
    <WrapperImage
      src={ImgUtil.getResizedImageUrl(mainImageUrl, '')}
      width={data.useCase === useCases.CENTER ? 1200 : 588}
      height={data.useCase === useCases.CENTER ? 714 : 560}
      alt={data.mainImage?.altText}
      className="FlexibleHero__MainImage"
    />
  )

  const logo = (
    <WrapperImage
      className="FlexibleHero__Logo"
      src={ImgUtil.getResizedImageUrl(logoUrl, '')}
      width={253}
      height={107}
      alt={data.logo?.altText}
    />
  )

  const cta = (
    <div className="FlexibleHero__Buttons">
      {data.cta?.map((button: any, i: number) => (
        <span className="FlexibleHero__Button" key={i}>
          <Button
            icon
            type={'primary'}
            theme={'light'}
            href={button?.externalUrl}
            text={button?.text}
          />
        </span>
      ))}
    </div>
  )

  const eyebrow = (
    <Typography type={'labelAlt'} className="FlexibleHero__Eyebrow text">
      {formatInlineCode(data.eyebrow)}
    </Typography>
  )

  const headline = (
    <Typography type={'display'} className="FlexibleHero__Headline text">
      {formatInlineCode(data.headline)}
    </Typography>
  )

  const subheadline = (
    <Typography type={'lead'} className="FlexibleHero__Subheadline text">
      {formatInlineCode(data.flexibleSubheadline)}
    </Typography>
  )

  const keyData = (
    <Typography type={'header5'} className="FlexibleHero__KeyData text">
      {formatInlineCode(data.keyData)}
    </Typography>
  )

  return (
    <FlexibleHeroContainer extraThemes={theme}>
      <GlobalContainer className="FlexibleHero__GlobalContainer">
        {showBreadcrumbs && (
          <div className="FlexibleHero__Breadcrumb">
            <Breadcrumbs
              theme={data.theme.toLowerCase()}
              currentPathname={location?.pathname || '/'}
              pageName={pageTitle}
              pageType={pageType}
              locale={locale}
              breadcrumb={breadcrumb}
            />
          </div>
        )}

        <div className="FlexibleHero__Wrapper">
          <VerticalGrid className="FlexibleHero__VerticalGrid">
            {data.logo && logo}
            {data.eyebrow && eyebrow}
            {data.headline && headline}
            {data.flexibleSubheadline && subheadline}
            {data.keyData && keyData}
            {data.cta && cta}
          </VerticalGrid>

          <MainImage className="FlexibleHero__MainImage_Container">
            {data.mainImage && mainImage}
          </MainImage>
        </div>
      </GlobalContainer>
    </FlexibleHeroContainer>
  )
}

export default FlexibleHero
